import { render, staticRenderFns } from "./Hand-sanitizer.vue?vue&type=template&id=c0fe07ac&"
import script from "./Hand-sanitizer.vue?vue&type=script&lang=js&"
export * from "./Hand-sanitizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports